import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import createCompositeChildrenValidation from '../util/createCompositeChildrenValidation';
var getExtraStyleProps = function getExtraStyleProps(props, extraStyleProps) {
  return extraStyleProps ? {
    style: _.pick(props, extraStyleProps)
  } : {};
};
export default (function (compositeDef) {
  var Composite = function Composite(props) {
    return /*#__PURE__*/React.createElement('div', _.assign({
      className: [compositeDef.className, props.className].join(' '),
      'data-aid': props.automationId
    }, getExtraStyleProps(props, _.keys(compositeDef.extraStyleProps))), props.children);
  };
  var compositeChildrenValidation = createCompositeChildrenValidation(compositeDef);
  Composite.displayName = compositeDef.displayName;
  Composite.getDisplayName = function () {
    return compositeDef.displayName;
  };
  Composite.propTypes = _.assign({
    className: PropTypes.string,
    /**
     * Automation ID - for testing purposes, please use dataHook instead
     * @deprecated
     */
    automationId: PropTypes.string,
    children: function children(props, propName, componentName) {
      return compositeChildrenValidation(props, propName, componentName);
    }
  }, compositeDef.extraStyleProps);
  return Composite;
});